module.exports = __webpack_public_path__ + "img/education.ee671db3.svg";